import { render, staticRenderFns } from "./CategorySalesReport.vue?vue&type=template&id=65a51a9f&"
import script from "./CategorySalesReport.vue?vue&type=script&lang=js&"
export * from "./CategorySalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports